import React, { useState, useEffect } from 'react';
import { Box, Tabs, Tab, Typography, Paper } from '@mui/material';
import { Schedule, Warning } from '@mui/icons-material';
import { useLocation } from 'react-router-dom';
import UpcomingActions from './UpcomingActions';
import OverdueActions from './OverdueActions';
import { getCurrentConfig } from '../../config/config';

const TabPanel = ({ children, value, index, ...other }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1 }}>
          {children}
        </Box>
      )}
    </div>
  );
};

const TopTabs = () => {
  const location = useLocation();
  const fromScreen = location.state?.fromScreen;
  
  // Determine initial tab based on fromScreen parameter
  const getInitialTab = () => {
    if (fromScreen === 'HomescreenOverdueActions') {
      return 1; // OverdueActions tab
    }
    return 0; // UpcomingActions tab (default)
  };

  const [value, setValue] = useState(getInitialTab());
  const config = getCurrentConfig();

  // Configuration for color
  const colorTopTab = config.Shortname === 'BHGRE' ? '#339933' : '#beb28b';

  useEffect(() => {
    const newTab = getInitialTab();
    setValue(newTab);
  }, [location]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', maxWidth: 1200, mx: 'auto', p: 2 }}>
      <Paper elevation={1}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="Actions tabs"
          variant="fullWidth"
          sx={{ 
            borderBottom: 1, 
            borderColor: 'divider',
            '& .MuiTabs-indicator': {
              backgroundColor: colorTopTab,
              height: 4,
            },
            '& .Mui-selected': {
              color: colorTopTab,
            },
          }}
        >
          <Tab 
            icon={<Schedule />} 
            label="Upcoming (Next 15 Days)" 
            id="0"
            aria-controls="tabpanel-0"
            sx={{ textTransform: 'none' }}
          />
          <Tab 
            icon={<Warning />} 
            label="Overdue (Past 6 Months)" 
            id="1"
            aria-controls="tabpanel-1"
            sx={{ textTransform: 'none' }}
          />
        </Tabs>

        <TabPanel value={value} index={0}>
          <UpcomingActions />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <OverdueActions />
        </TabPanel>
      </Paper>
    </Box>
  );
};

export default TopTabs;